<template>
  <div class="max-vh" v-loading="loaded">
    <Header/>
    <section class="main" v-if="!loaded">
      <div class="container">
        <div class="main__header">
          <div class="main__currency" v-html="get_currency(this.$route.params.id)">
          </div>
          <h1 class="main__title">
            Token  {{this.$route.params.id}} explorer
          </h1>
          <button class="main__button">
            Buy
          </button>
        </div>
        <div class="overview">
          <div class="overview__token">
            <dl class="overview__list">
              <dt class="termin">Token name</dt>
              <dd class="definition"> {{this.$route.params.id}}</dd>
              <dt class="termin">Token total supply</dt>
              <dd class="definition"> {{detailData.supply}}</dd>
              <dt class="termin">Creator</dt>
              <dd class="definition" style="height: 20px;">
                <div class="definition__purse">
                  <router-link :to="`/address/${detailData.creator}/tx/1`">{{detailData.creator}}</router-link>
                </div>
                <div class="definition__copy">
                  <a   v-clipboard:success="copy_success"
                       v-clipboard="() => detailData.creator" class="copy__link">
                    <ion-icon name="copy" class="copy"></ion-icon>
                  </a>
                </div>
              </dd>
              <dt class="termin">Total transactions</dt>
              <dd class="definition">{{detailData.totalTX}}</dd>
              <dt class="termin">Total number of holders</dt>
              <dd class="definition">{{detailData.richCount}}</dd>
              <dt class="termin">Decimals</dt>
              <dd class="definition">{{detailData.divisibility}}</dd>
            </dl>
          </div>
          <div class="overview__graphic">
            <div class="title">Total supply</div>
            <div class="graphic">
              <ChartContainer v-bind:totalSupply.sync="detailData.supply"/>
            </div>
          </div>
        </div>
        <router-view></router-view>
      </div>
    </section>
    <Footer/>
  </div>
</template>

<script>
  import Chart from './components/Chart';
  import TableDetail from './components/TableDetail';
  import TableTransactions from '../components/TableTransactions';
  import Header from '../components/Header';
  import TableHolders from './components/TableHolders';
  import MosaicProxy from '../../proxies/MosaicProxy';
  import { createNamespacedHelpers } from 'vuex';
  import ChartContainer from './components/ChartContainer';
  import Footer from '../components/Footer';
  import { get_currency } from '../../utils/currency';
  import { copy_success } from '../../utils/copy';
  const { mapState, mapActions } = createNamespacedHelpers('core');

  export default {
    name: 'Index',
    components: {
      Footer,
      ChartContainer,
      TableHolders,
      Header,
      TableTransactions,
      TableDetail,
      Chart
    },
    methods: {
      ...mapActions(['get_count_info', 'clear_count_info']),
      getRandomInt() {
        return Math.floor(Math.random() * (20 - 19 + 1)) + 5;
      }
    },
    watch: {
      path: function (v) {
        this.$router.push({
          name: v,
          params: {
            ...this.$route.params,
            num: 1
          }
        });
        console.info(v);
      }
    },
    beforeDestroy() {
      this.clear_count_info();
    },
    async mounted() {
      const mosaics_proxy = new MosaicProxy();
      const { totalTX, richCount } = await this.get_count_info();
      const detail = await mosaics_proxy.get_mosaic_detail(this.$route.params.id);
      if(detail.namespace !== 'arus') {
        this.$router.push('/404')
      }
      this.totalSupply = detail.initialSupply;
      this.detailData = {
        supply: detail.initialSupply,
        height: detail.height,
        creator: detail.creator,
        totalTX: totalTX,
        richCount: richCount,
        divisibility: detail.divisibility
      };
      this.loaded = false;
    },
    data: function () {
      return {
        totalSupply: 0,
        path: this.$route.name,
        loaded: true,
        detailData: [],
        get_currency,
        copy_success
      };
    }
  };
</script>

<style scoped>

</style>
